import { render, staticRenderFns } from "./MechantsDashboard.vue?vue&type=template&id=ccb7c6dc&"
import script from "./MechantsDashboard.vue?vue&type=script&lang=js&"
export * from "./MechantsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports